import { createIconComponent } from './helpers';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'

export const UpArrowIcon = createIconComponent(faAngleUp);
